import { combineReducers } from "redux";

import { default as execute } from "./execute";
import { default as validate } from "./validate";
import { default as authorize } from "./authorize";

export default combineReducers({ execute, validate, authorize });
export * from "./execute";
export * from "./validate";
export * from "./authorize";
